import { Tab, Tabs } from "@mui/material";
import Text from "../../../../components/Text";
import { NavDataType } from "../../../../constants/common";

type PatientTabsProps = {
  tabs: NavDataType[];
  activeTab: string;
  onTabChange: (tab: string, ind: number) => void;
};

const PatientTabs = ({ tabs, activeTab, onTabChange }: PatientTabsProps) => {
  return (
    <Tabs
      sx={{
        "& .MuiButtonBase-root": {
          padding: 0,
          minWidth: 0,
          marginRight: "30px",
        },
        marginLeft: "4%",
      }}
      textColor={"inherit"}
      TabIndicatorProps={{
        sx: {
          marginBottom: "8px",
          bgcolor: "white",
        },
      }}
      variant={"scrollable"}
      value={activeTab}
    >
      {tabs.map((tab, index) => {
        return (
          <Tab
            // disabled={tab.value === "dashboard"}
            key={tab.value}
            sx={{ marginRight: "5px" }}
            value={tab.value}
            onClick={() => onTabChange(tab.value, index)}
            // onMouseOver={(e) => {
            //   onClickMenuItem(tab, e);
            //   setCurrentTab(tab.value);
            // }}
            // onMouseLeave={() => {
            //   handleCloseUserMenu();
            // }}
            label={<Text c={"white"}>{tab.label}</Text>}
          />
        );
      })}
    </Tabs>
  );
};

export default PatientTabs;
